export default __webpack_public_path__ + "static/media/wyndham4.02fb8ca8.png";